import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=7f141c70&scoped=true&"
import script from "./FormContact.vue?vue&type=script&lang=ts&"
export * from "./FormContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f141c70",
  null
  
)

export default component.exports